import { render, staticRenderFns } from "./supList.vue?vue&type=template&id=36ce1311&scoped=true"
import script from "./supList.vue?vue&type=script&lang=js"
export * from "./supList.vue?vue&type=script&lang=js"
import style0 from "./supList.vue?vue&type=style&index=0&id=36ce1311&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ce1311",
  null
  
)

export default component.exports